//@flow

import type { WalletActionType } from './actions';
import type { StateType } from '../reducers';

export type WalletStateType = {|
  walletForfeitureData: Object,
|};

const initialWalletState: WalletStateType = {
  walletForfeitureData: {},
};

export const walletReducer = (state: StateType = initialWalletState, action: WalletActionType) => {
  switch (action.type) {
    case 'SET_WALLET_FORFEITURE_DATA':
      return {
        ...state,
        walletForfeitureData: action.payload,
      };
    default:
      return state;
  }
};
